import { z } from "zod";

/** Mirrors backend `EmrAutoTuneEntry` in system_settings_models.py. */
export const emrAutoTuneSchema = z.object({
  role_arn: z.string().catch(""),
  enabled: z.boolean().catch(true),
});

export type EmrAutoTuneEntry = z.infer<typeof emrAutoTuneSchema>;

const EMPTY_ENTRY = emrAutoTuneSchema.parse({});

export const parseEmrAutoTuneIntegrations = (raw: unknown): EmrAutoTuneEntry[] =>
  z.array(emrAutoTuneSchema.catch(EMPTY_ENTRY)).catch([]).parse(raw);

export interface EmrAutoTuneIntegrationFormProps {
  entry: EmrAutoTuneEntry;
  onChange: (entry: EmrAutoTuneEntry) => void;
}
